import {
    Model
} from '@/lib/BaseModel';
import fieldSpec from '@/models/commonFieldsSchema';


var LoginSchema = {

    email: {
        label: fieldSpec.email.label,
        truncate: fieldSpec.email.maxLength,
        validation: {
            email: 'Must be a properly formatted email address.',
            required: 'Must be filled in.'
        }
    },

    password: {
        label: fieldSpec.password.label,
        truncate: fieldSpec.password.maxLength,
        validation: {
            required: 'Must be filled in.'
        },
    }

}

var Login = Model.make('Login', LoginSchema);

export {
    Login
};